import React, { useCallback, useState } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { BonusStatus } from 'constants/appEnums';
import { NewSigningDetails } from 'components/BonusCardDetails';
import { devPromoTeam } from 'test/testData';
import { ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import NewSigningSelect from './NewSigningSelect';
import NewSigningReveal from './NewSigningReveal';
import routes from 'constants/routes';

type JourneyState = 'Unavailable' | 'Available' | 'Active' | 'Select' | 'Reveal';

// TO-DO: calc initial state of card description based on users entry/promo status
const calcInitialState = (): JourneyState => {
  return 'Available';
};

const NewSigning: React.FC = () => {
  // TO-DO: Select Entry Team from redux
  const entryTeam: ITeamMember[] = devPromoTeam.team;
  const [state, setState] = useState(() => calcInitialState());

  const onActivate = useCallback(() => {
    setState('Select');
  }, []);

  const onConfirmSwap = useCallback((_selnNum: number) => {
    // TO-DO: API Request to Swap Selection
    setState('Reveal');
  }, []);

  const history = useHistory();

  const onRevealComplete = useCallback(() => {
    history.push(generatePath(routes.FIVES.route));
  }, [history]);

  switch (state) {
    case 'Unavailable':
      return <NewSigningDetails bonusState={BonusStatus.unavailable} />;
    case 'Available':
      return <NewSigningDetails bonusState={BonusStatus.available} onActivateClick={onActivate} />;
    case 'Active':
      return <NewSigningDetails bonusState={BonusStatus.active} />;
    case 'Select':
      return <NewSigningSelect team={entryTeam} onConfirmSwap={onConfirmSwap} />;
    case 'Reveal':
      return <NewSigningReveal newTeamMember={devPromoTeam.team[0]} onRevealComplete={onRevealComplete} />;
  }
};

export default NewSigning;
